import {booleanAttribute, Component, EventEmitter, Input, numberAttribute, Output} from '@angular/core';
import {PageEvent} from '@angular/material/paginator';
import {TranslatePipe} from '@ngx-translate/core';
import {IconComponent} from '../../icons/icon.component';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  imports: [
    TranslatePipe,
    IconComponent,
    FormsModule,
  ],
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent {
  @Input({transform: numberAttribute}) totalCount = 0;
  @Input() pageSize = 6;
  @Input() currentPage = 0;
  @Input({transform: booleanAttribute}) loading = false
  @Output() pageChange = new EventEmitter<PageEvent>();

  showTotalCount = true;
  showPageSize = false;

  constructor() {
  }

  get displayCurrentPage(): number {
    return this.currentPage + 1
  }

  get length(): number {
    if (this.totalCount % this.pageSize === 0) {
      return Math.floor(this.totalCount / this.pageSize);
    }
    return Math.floor(this.totalCount / this.pageSize) + 1;
  }

  onChangePage(newDisplayPage: number): void {
    const cp = newDisplayPage - 1
    if (cp % 1 === 0 && cp >= 0 && cp <= this.length) {
      const pageEvent = {
        pageIndex: cp,
        pageSize: this.pageSize,
        length: this.length - 1,
      };

      this.pageChange.emit(pageEvent);
    }
  }
}
